module.exports = __webpack_public_path__ + "img/jtb-avatar-7572.99ffde13.jpg";